import { AsText, useModal } from '@adserve/adserve-react-components';
import React, { useState } from 'react';
import { UpdateBillingPlanInvoice } from '../../../services/CampaignsDataService';

const ForwardSchedulePoNumber   = ({
    billingPlanInvoice,
    getData,
    campaignId,
    readOnly = false
}) => {
    const { addMessage } = useModal();
    const [poNumber, setPoNumber] = useState(billingPlanInvoice.poNumber);

    /**
     * onChange event handler for PoNumber AsText box.
     * @param {Event} event - onChange event
     */
    const onChange = (event) => {
        setPoNumber(event.target.value);
    };

    /**
     * keyDown event handler for PO Number AsText box.
     * Saves on pressing enter.
     * @param {Event} e - keyDown event
     * @returns
     */
    const onKeyDown = async (e) => {
        if (!billingPlanInvoice.id || (e.code !== 'Enter' && e.code !== 'NumpadEnter')) {
            return;
        }
        e.preventDefault();
        try {
            await UpdateBillingPlanInvoice({ id: billingPlanInvoice.id, campaignId, poNumber });
        } catch (err) {
            addMessage({
                message: window.translate('An error occurred when trying to save changes to the PO Number.'),
                buttons: [{ text: window.translate('OK') }]
            });
        }
        if (typeof getData === 'function') {
            getData();
        }
    };

    return (
        <AsText
            value={poNumber}
            onChange={onChange}
            onKeyDown={onKeyDown}
            disabled={readOnly}
            inputStyle={{ width: '100%', height: '100%', borderRadius: 0, boxSizing: 'border-box', padding: 5 }}
        />
    );
}

export default ForwardSchedulePoNumber;
